$(document).on('click', '#collection-filters-container .cf-title', function(e){
  e.preventDefault();

//   if($(this).hasClass('expanded')) {
//     $('#collection-filters-container .cf-options-container:not(.open)').removeClass('active');
//   setTimeout(function(){
//       $('#collection-filters-container .cf-title').removeClass('expanded');
//     }, 200);
//   }
//   else {
    //$('#collection-filters-container .cf-title').removeClass('expanded');
    //$('#collection-filters-container .cf-options-container:not(.open)').removeClass('active');

    $(this).next('.cf-options-container').toggleClass('active');
    $(this).toggleClass('expanded');

//   }

});

$(document).on('click', '.product-block .switches-container .option-selectors .selector-wrapper ul.size li.swatchContainer label.bg-edit', function() {
  $(this).parent().parent().parent().parent().parent().parent().siblings('a.product-link').trigger('click');
});

$('.multi-level-nav a.has-children').parent().addClass('sub');

if($(window).width() <= 958  ) {
  $('.multi-level-nav a.has-children').attr('href','#');
}

setTimeout(function(){

  $(document).on('click', '.t-lightbox-thumbs > a', function(){
     $('.t-lightbox-thumbs > a').removeClass('active');
     $(this).addClass('active');
  });



},200);

setTimeout(function(){
  if($('#collection-filters-container .cf-title:first-child').text() == 'Type') {



    if($(window).width() < 768) {
      $('#collection-filters-container .cf-title:first-child').text($('.filter h1.majortitle').text());
    }
    else {
      $('#collection-filters-container .cf-title:first-child').hide();
       $('#collection-filters-container .cf-options-container:nth-child(2)').addClass('open');
    }

  }

  if($(window).width() <= 958) {
     $('ul[data-menu-handle="main-menu"] li.sub > a').attr('href','#');
  }


},900);


$(document).on('click', '.chart ul li', function(){
     $('.chart ul li').removeClass('active');
     $(this).addClass('active');

  	$('.chart .table > div').removeClass('active');
   	$('.chart .table > div.'+$(this).attr('id')).addClass('active');

});


$(document).on('click', '.liststore .title', function(){

  	if(!$(this).parent().hasClass('active')) {
      	$('.liststore > div').removeClass('active');
      	$(this).parent().addClass('active');
      }

    else {
       $('.liststore > div').removeClass('active');
    }
});

$(document).on('click', '#fancybox-close', function(){
     $('body').removeClass('noscroll');

});

$(document).on('click', 'body.reveal-mobile-nav ul[data-menu-handle="main-menu"] li.sub', function(){
  if($(this).hasClass('active')) {
  	$('body.reveal-mobile-nav ul[data-menu-handle="main-menu"] li.sub').removeClass('active');
  }
  else {
    $('body.reveal-mobile-nav ul[data-menu-handle="main-menu"] li.sub').removeClass('active');
    $(this).addClass('active');
  }
});



if($(window).width() > 1024) {
  // FADEIN
  $('body').addClass('active');

  // FADEOUT
  $('body').on('click', 'a[href*="' + window.location.hostname + '"], a[href*=".html"], a[href^="/"], a[type="submit"]', function(e){
      if( $(this).attr('data-category') == undefined && $(this).attr('data-filter') == undefined && $(this).attr('data-load-more') == undefined && $(this).attr('data-loadmore') == undefined && $(this).parent().attr('data-pagination') == undefined  && $(this).parent().attr('data-link') == undefined && !$(this).parent().hasClass('main-image') && !$(this).parent().hasClass('slick-track') && !$(this).parent().hasClass('thumbnails') ) {
          if ($(this).attr('href').indexOf('_=pf') == -1) { // BoostCommerce add, for prevent reloading after filtering
              e.preventDefault();
              $(this).addClass('click');

              $('body').removeClass('active')

              setTimeout(function() {
                window.location.href = $('a.click').attr('href');
              }, 400);
          }
      }
  });
} else {
  $('body').addClass('mobile');
  	// FADEOUT
    $('body').on('click', 'a[href*="' + window.location.hostname + '"], a[href*=".html"], a[href^="/"], a[type="submit"]', function(e){
      if( $(this).attr('data-category') == undefined && $(this).attr('data-filter') == undefined && $(this).attr('data-load-more') == undefined && $(this).attr('data-loadmore') == undefined && $(this).parent().attr('data-pagination') == undefined  && $(this).parent().attr('data-link') == undefined && !$(this).parent().hasClass('main-image') && !$(this).parent().hasClass('slick-track') && !$(this).parent().hasClass('thumbnails') ) {
          if ($(this).attr('href').indexOf('_=pf') == -1) { // BoostCommerce add, for prevent reloading after filtering
              e.preventDefault();
              $(this).addClass('click');

              $('body').removeClass('mobile')

                window.location.href = $('a.click').attr('href');
          }
      }
  });
}

//REMOVE PLACEHOLDER
$('.contact-form input,textarea').focus(function(){
   $(this).data('placeholder',$(this).attr('placeholder'))
          .attr('placeholder','');
}).blur(function(){
   $(this).attr('placeholder',$(this).data('placeholder'));
});

$(document).on('click', 'span.up', function(){
   var Value = $('input#quantity').val();
  	Value = ++Value;
   $('input#quantity').val(Value);

});

$(document).on('click', 'span.down', function(){
   var Value = $('input#quantity').val();
  	Value = --Value;
  if(Value != 0) {
    $('input#quantity').val(Value);
  }
});

$('input#quantity').on('keydown', function(e){
    if(!((e.keyCode > 95 && e.keyCode < 106)
      || (e.keyCode > 47 && e.keyCode < 58)
      || e.keyCode == 8)) {
        return false;
    }
});

$('#option-color li').each(function(e){
    var Value = $(this).attr('data-value-clean');

      setTimeout(function(){
        // $('.productSlideshow a[data-full-size-url*="' + Value.replace(' ', '.').replace('/', '.').replace('-', '.').replace('-', '.') + '"]');
        // $('.productSlideshow a[data-full-size-url*="' + Value.replace(' ', '.').replace('/', '.').replace('-', '.').replace('-', '.') + '"]').fadeIn(400).addClass(Value);
        console.log('.productSlideshow a[data-full-size-url*="' + Value.replace(' ', '.').replace('/', '.').replace('-', '.').replace('-', '.') + '"]');
      },10);
});


$('#option-color li').on('click', function(e){
    var Value = $(this).attr('data-value-clean');
 	var key = "."+Value;

    if(!$(this).hasClass('selected')) {
      $('#option-color li').removeClass('selected');
     $(this).addClass('selected');
      // $(this).parent().parent().find('select').trigger('change');
      setTimeout(function(){
        $('.productSlideshow').slick('slickUnfilter');
        //$('.productSlideshow').slick('slickFilter',key).slick('refresh');
        //$('.productSlideshow').slick('slickGoTo', 0);
      },10);

      // $('[data-colour-label]').text(Value);

      // $('#product-color').text(Value);
    }

    $('a.slide.shows-lightbox').removeAttr("href").off('click');


});

$('#option-color li.selected').removeClass('selected').click();

$('.productSlideshow').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true
});

$('#option-color li').hover(
  function() {
    $(this).find('.tooltip').addClass('visible');
  }, function() {
    $(this).find('.tooltip').removeClass('visible');
  }
);

// INFINITE SCROLL
var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    var loadingImage;
    pInfScrNode = $('.more a').last();
    pInfScrURL = $('.more a').attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0) {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
           pInfScrLoading = true;
        },
        success: function(data) {
          var filteredData = $(data).find(".product-list .product-block");
          $(".product-list").append(filteredData.css('opacity', 1));

          if($(data).find('.more a').length > 0) {
          	$('.more a').attr("href", $(data).find('.more a').attr('href'));
          } else {
            $('.more a').remove()
          }

          pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
}

// Hides the "This item is sold out" text if the item is coming soon.
$('#main-product-detail .detail .description p').each(function(){
  // console.log("text: " + $(this).text());
  var value = $(this).text();
  console.log("text: " + value);
  var substring = "COMING SOON";
  if (value.includes(substring)) {
    $('#main-product-detail .detail .product-form p em').remove();
  }
});


// Collection page show colour swatches if two or more
// $(window).on('load', function(){
//   $('.switches-container ul#option-0').each(function () {
// 	if($(this).children('li').length >= 2) {
// 		$(this).parents().parents().siblings('label.product-label').show();
// 	} else {
// 		$(this).parents().parents().siblings('label.product-label').hide();
// 	}
//   });
// });

// Swatches click in the collection page
$(document).on('click', '.product-block .product-label.available-in', function(e) {
	e.preventDefault();
  if($(this).hasClass('active')){
    $(this).removeClass('active');
    $(this).siblings('.option-selectors').hide();
    $(this).parent().removeClass('active');
    $(this).parent().prev().children('.product-info').removeClass('active');
    $(this).parent().height(19);
  } else {
    $(this).addClass('active');
    $(this).siblings('.option-selectors').show();
    
    if ($(this).hasClass('multiple-colours')) {
      var height = $(this).siblings('.option-selectors').find('#option-color').innerHeight() - 4;
      $(this).parent().height(height);
      $(this).parent().addClass('active');
      $(this).parent().prev().children('.product-info').addClass('active');
    }
  }
});

$(document).on('click', '.newsletter-toggle', function(e) {
	e.preventDefault();

  if($('.menu-item.item-toggle').length && $('.menu-item.item-toggle').hasClass('active')) {
    var activeMenuItem = $('.menu-item.item-toggle.active');
    activeMenuItem.removeClass('active');
    activeMenuItem.siblings('.content').slideUp(300);
  }

  if($('#pagefooter #shopify-section-footer .information-toggle').hasClass('active')) {
  	$('#pagefooter #shopify-section-footer .information-toggle').removeClass('active');
  	$('#pagefooter #shopify-section-footer .nav-row .multi-level-nav').slideUp(300);
  }

  if($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).siblings('.newsletter').slideUp(300);
  } else {
    $(this).addClass('active');
    $(this).siblings('.newsletter').slideDown(300);
    $('#mailinglist_email').focus();
  }

});

$(document).on('click', '#pagefooter #shopify-section-footer .information-toggle', function(e) {
	e.preventDefault();

  if($('.menu-item.item-toggle').length && $('.menu-item.item-toggle').hasClass('active')) {
    var activeMenuItem = $('.menu-item.item-toggle.active');
    activeMenuItem.removeClass('active');
    activeMenuItem.siblings('.content').slideUp(300);
  }

	if($('.newsletter-toggle').hasClass('active')){
  	$('.newsletter-toggle').removeClass('active');
  	$('.newsletter').slideUp(300);
  }
  $(this).toggleClass('active');
  $(this).siblings('#pagefooter #shopify-section-footer .nav-row .multi-level-nav').slideToggle(300);
});

// Wear with carousel
$('.wear-with-slideshow').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 959,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// Size guide popup
$('a#inline').magnificPopup({
    type: 'inline',
    mainClass: 'popup',
    callbacks: {
      open: function() {
          $('html').css('margin-right', 0);
      }
    }
});


// Product detail toggle
$(document).on('click', '.toggle', function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
		$(this).removeClass('active');
        $(this).siblings('.info').slideUp(300);
    } else {
        $(this).parents().siblings().children('.info').slideUp(300);
        $(this).parents().siblings().children('.toggle').removeClass('active');
        $(this).addClass('active');
        $(this).siblings('.info').slideDown(300);
    }
  	return false;
});

// Select2 on product size select
$('html.no-touch select#option-size').select2({
    placeholder: "Select a size",
    allowClear: false
});


// Scroll top button
 $(window).scroll(function() {
   if ($(window).width() > 959) {
     var hh = $(window).height();
     if ($(this).scrollTop() > 200){
       $('#pagefooter span.scrollTop').show();
     } else {
       $('#pagefooter span.scrollTop').hide();
     }
   }
 });

$(document).on('click', 'a.scrollTopButton', function(e) {
	e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 500);
    return false;
});

$(document).on('click', '.search-box', function(e) {
    $('#pageheader .search-box .search-form input[type="text"]').focus();
});


// Mobile search
$(document).on('click', 'a.mobileSearchButton', function(e) {
  e.preventDefault();
  $('body').removeClass('reveal-mobile-nav');
  if($('#pageheader .search-box').hasClass('active')) {
    $('#pageheader .search-box').removeClass('active');
  } else {
    $('#pageheader .search-box').addClass('active');
    $('#pageheader .search-box .search-form input[type="text"]').focus();
  }
});


$(document).on('click', '.searchClose', function(e) {
  $('#pageheader .search-box').removeClass('active');
});

$(document).on('click', '#bc-sf-filter-tree-mobile-button', function(e) {
  $('body').removeClass('reveal-mobile-nav');
  $('.mobile-nav-toggle').removeClass('menu-open');
  if($(this).hasClass('bc-sf-filter-tree-mobile-button-open')){
    $('body').addClass('refineOpen');
  } else {
    $('body').removeClass('refineOpen');
  }
});


// Disable image click on mobile



$(window).on('load', function(){
  if($(window).width() > 959) {
  	$('.cart-summary select#currencies').select2();
  } else {
    $('.mobile-currency-switcher select#currencies').select2().on('select2:open',function(){

            $('.select2-dropdown--above').attr('id','fix');
            $('#fix').removeClass('select2-dropdown--above');
            $('#fix').addClass('select2-dropdown--below');

        });;
  }

  $('.multi-level-nav a.has-children').parent().addClass('sub');

  $('a.slide').removeAttr("href");

  if($(window).width() <= 958) {
  	$('.multi-level-nav a.has-children').attr('href','#');
  }

  $('body.reveal-mobile-nav a.has-children').click(function(e) {
    e.preventDefault();
    if($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
    } else {
        $('body.reveal-mobile-nav ul[data-menu-handle="main-menu"] li.sub').removeClass('active');
        $(this).parent().addClass('active');
    }
    return false;
  });

});

$(document).on('click', 'span.down', function(){
   var Value = $('input#quantity').val();
  	Value = --Value;
  if(Value != 0) {
    $('input#quantity').val(Value);
  }
});


$(window).resize(function() {
  $('html.no-touch select#option-size').select2({
    placeholder: "Select a size",
    allowClear: false
  });
});

// Hero Video controls
$(document).ready(function(){

  $('[data-video-control]').on('click', function(e) {
    $(this).closest('section').toggleClass('is-playing');
    let video = $(this).next().get(0);
    video.paused ? video.play() : video.pause();
  });

});

// Tab controls in boutiques page - DESKTOP
$('.menu-items .menu-item').on('click', function(e) {
  $(this).removeClass('active');
  $('.content-block.active').removeClass('active');
  var nextMenuItemID = $(this).data('tab-id');
  var nextMenuItem = $('.content-block#' + nextMenuItemID);
  nextMenuItem.addClass('active');
  nextMenuItem.find('[data-tab-id="' + nextMenuItemID + '"]').addClass('active');
});

// Tab controls in boutiques page - Mobile
$(document).on('click', '.menu-item.item-toggle', function(e) {
	e.preventDefault();
  if($('.newsletter-toggle').hasClass('active')){
    $('.newsletter-toggle').removeClass('active');
    $('.newsletter').slideUp(300);
  }

  if($('#pagefooter #shopify-section-footer .information-toggle').hasClass('active')){
  	$('#pagefooter #shopify-section-footer .information-toggle').removeClass('active');
  	$('#pagefooter #shopify-section-footer .nav-row .multi-level-nav').slideUp(300);
  }

  var currentMenuItemID = $(this).data('tab-id');

  if($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).siblings('.content').slideUp(300);
  } else {
    $(this).siblings('.item-toggle.active').removeClass('active');
    $(this).siblings('.content').slideUp(300);
    $(this).addClass('active');
    $(this).siblings('.content#' + currentMenuItemID).slideDown(300);
  }
});
